import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Button from "../../atoms/button"
import { Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import ExploreButtons from "../../molecules/explore-buttons"
import InternalRoutes from "../../util/internal-routes"

/** Highlighted topics to link to */
const ExploreTopics = () => {
  const { backgroundImage } = useStaticQuery(graphql`
    query {
      backgroundImage: file(
        relativePath: { eq: "6_BLOG/categories/explore_categories.jpeg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1154) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <BlogGrid noPadding={{ sm: true, md: true }}>
      <ExploreButtons
        title={"Explore Popular Topics"}
        background={backgroundImage.childImageSharp.fluid}
      >
        <Button.Link
          to={InternalRoutes.Blog(
            { slug: "product" },
            { slug: "indoor-mapping" }
          )}
        >
          Indoor Mapping
        </Button.Link>
        <Button.Link
          to={InternalRoutes.Blog({ slug: "company" }, { slug: "culture" })}
        >
          Culture
        </Button.Link>
        <Button.Link
          to={InternalRoutes.Blog({ slug: "use-cases" }, { slug: "retail" })}
        >
          Retail
        </Button.Link>
        <Button.Link
          to={InternalRoutes.Blog({ slug: "use-cases" }, { slug: "offices" })}
        >
          Offices
        </Button.Link>
        <Button.Link
          to={InternalRoutes.Blog({ slug: "product" }, { slug: "positioning" })}
        >
          Positioning
        </Button.Link>
        <Button.Link
          to={InternalRoutes.Blog(
            { slug: "company" },
            { slug: "customer-examples" }
          )}
        >
          Customer Examples
        </Button.Link>
      </ExploreButtons>
      <Spacer height={{ sm: "8px", md: "16px", lg: "48px" }} />
    </BlogGrid>
  )
}

export default ExploreTopics
